if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        const controls = this.querySelector('.product-media-modal__controls');
        controls?.addEventListener('pointerup', (event) => event.stopPropagation());
        controls?.querySelector('.product-media-modal__previous')?.addEventListener('click', () => this.changeMedia(-1));
        controls?.querySelector('.product-media-modal__next')?.addEventListener('click', () => this.changeMedia(1));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.changeMedia(-1);
          if (event.key === 'ArrowRight') this.changeMedia(1);
        });

        const content = this.querySelector('.product-media-modal__content');
        content?.addEventListener(
          'touchstart',
          (event) => {
            this.touchStartX = event.changedTouches[0].clientX;
            this.touchStartY = event.changedTouches[0].clientY;
          },
          { passive: true }
        );
        content?.addEventListener(
          'touchend',
          (event) => {
            if (this.touchStartX == null || this.touchStartY == null) return;
            const deltaX = event.changedTouches[0].clientX - this.touchStartX;
            const deltaY = event.changedTouches[0].clientY - this.touchStartY;
            this.touchStartX = null;
            this.touchStartY = null;

            if (Math.abs(deltaX) >= 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
              this.changeMedia(deltaX < 0 ? 1 : -1);
            }
          },
          { passive: true }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const index = this.mediaItems.findIndex((item) => item.getAttribute('data-media-id') === mediaId);
        this.setActiveMedia(index < 0 ? 0 : index);
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      changeMedia(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;
        const activeIndex = items.findIndex((item) => item.classList.contains('active'));
        const nextIndex = (activeIndex + direction + items.length) % items.length;
        this.setActiveMedia(nextIndex);
      }

      setActiveMedia(index) {
        const items = this.mediaItems;
        const activeMedia = items[index];
        if (!activeMedia) return;

        items.forEach((item) => {
          item.classList.toggle('active', item === activeMedia);
          item.setAttribute('aria-hidden', item === activeMedia ? 'false' : 'true');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = 0;

        const counter = this.querySelector('[data-media-current]');
        if (counter) counter.textContent = index + 1;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
